import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	ZaznamId: null as number | null,
	VyrobekndOzn: null as string | null,
	MarketKod: null as string | null,
	Text: null as string | null,
	PodporaGdPrp: null as boolean | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	VstupDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	EditDat: null as Date | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
